'use client'

import UIFlex from '@components/ui/UIFlex'
import { pxToRem } from '@ui/style/muiTheme'
import UIText from '@components/ui/UIText'
import color from '@ui/style/color.theme'

const DimdLayer = () => {
	return (
		<UIFlex
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			sx={{
				width: '100%',
				height: '100%',
				position: 'absolute',
				backgroundColor: 'rgba(97, 146, 174, 0.95)',
				left: 0,
				top: 0,
				zIndex: 2,
			}}
		>
			<UIText
				sx={{
					fontSize: pxToRem(16),
					lineHeight: pxToRem(24),
					color: color.colWhite,
					fontWeight: 700,
					textAlign: 'center',
				}}
			>
				데이터 집계 중 입니다.
				<br /> 잠시 후 집계현황을 알려드리겠습니다.
			</UIText>
		</UIFlex>
	)
}

export default DimdLayer
